import { html, type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartBar } from './component.js';

export const renderChartBar = (component: DeesChartBar): TemplateResult => {
  return html`
    <dees-tile>
      <div slot="header" class="chartHeader">
        <span class="chartLabel">${component.label}</span>
      </div>
      <div class="chartContainer"></div>
    </dees-tile>
  `;
};
